import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import * as signalR from '@microsoft/signalr';
import { filter, interval, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoadingApplicationComponent } from './components/loading-application/loading-application.component';
import { UserService } from './services/user/user.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription();
  user = { token: '', sessionId: '' };

  title: string = '7-portal-colaborador-portal';
  constructor(
    private userService: UserService,
    private storage: Storage,
    private update: SwUpdate,
    private router: Router,
    private modalController: ModalController,
    private activeRoute: ActivatedRoute,
  ) {
    if (update.isEnabled) {
      interval(10000).subscribe(() => update.checkForUpdate());
    }
    this.updateClient();
  }

  sessionConnection: any;
  id: any;

  async ngOnInit() {
    await this.storage.create();

    if (!this.sessionConnection) {
      this.sessionConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${environment.apiUrl}users/Auth/authenticate`)
        .build();

      this.sessionConnection.start().then(
        () => {},
        (error: any) => {
          console.error('Error session connection => ', error);
        },
      );
    }

    await this.sessionConnection.on('Send', async (sessionId: string) => {
      await this.storage.get('sessionId').then(x => {
        if (x == sessionId) {
          this.userService.clearSession();
        }
      });
    });

    let user = { token: '', sessionId: '' };
    await this.storage.get('token').then(res => {
      user.token = res;
    });

    await this.storage.get('sessionId').then(res => {
      user.sessionId = res;
    });

    if (user.token && user.sessionId) {
      await this.userService
        .getSession(user)
        .toPromise()
        .then(
          res => {},
          async error => {
            if (error.error.message.includes('Usuário logado em outro dispositivo!')) {
              await this.userService.clearSession();
            } else if (error.error.message.includes('Sessão expirada!')) {
              await this.userService.logout(true);
            }
          },
        );
    }

    this.subscriptions.add(
      this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
        this.pauseAllVideoElements();
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private pauseAllVideoElements() {
    document.querySelectorAll('video').forEach((video: HTMLVideoElement) => {
      if (!video.paused) {
        video.pause();
      }
    });
  }

  async updateClient() {
    this.update.versionUpdates.subscribe(async event => {
      if (event.type === 'VERSION_READY') {
        const modal = await this.modalController.create({
          component: LoadingApplicationComponent,
          backdropDismiss: false,
          cssClass: 'modal-loading',
        });
        await modal.present();

        await this.update.activateUpdate();
        setTimeout(() => {
          location.reload();
        }, 1000);
      }
    });

    // if (this.update.isEnabled) {
    // 	this.update.versionUpdates.subscribe(event => {
    // 		if (event.type == 'VERSION_READY') {
    // 			if (this.route.url.includes('qrcode')) {
    // 				const id = this.activeRoute.snapshot.params['id'];

    // 				if (id == 'e81e1872-9158-40cb-b91d-ee29cf374cd4') {
    // 					console.log('this.route.url', this.route.url);
    // 					localStorage.setItem('previousRoute', this.route.url);
    // 				}
    // 			}

    // 			new Promise(async (resolve, reject) => {
    // 				const modal = await this.modalController.create({
    // 					component: LoadingApplicationComponent,
    // 					backdropDismiss: false,
    // 					cssClass: 'modal-loading',
    // 				});
    // 				await modal.present();
    // 				setTimeout(async () => {
    // 					await this.update.activateUpdate().then(async () => {
    // 						setTimeout(() => {
    // 							resolve(location.reload());
    // 						}, 1000);
    // 					});
    // 				}, 1000);
    // 			});
    // 		} else {
    // 			console.info(event);
    // 			console.info(event.type);
    // 		}
    // 	});
    // }
  }

  blockRightClick(event: MouseEvent) {
    event.preventDefault();
  }
}
